import { takeLatest, takeEvery, put, call, select } from 'redux-saga/effects'
import { AnyAction } from 'redux'
import * as Constants from '../constants'
import * as Services from '../services'
import { IResponseStatus } from '../reducers'
import { RootState } from '../../../store'
import { parseResponse } from '../../../store/saga/responseParser'

const getApiKey = (state: RootState) => state.authReducer.token

function* getTasks(action: AnyAction) {
  try {
    const api_key: string = yield select(getApiKey)
    const response: IResponseStatus = yield call(
      Services.tasksByPageService,
      api_key,
      action.size,
      action.page,
      action.filters,
      action.sort,
    )

    yield call(
      parseResponse,
      response,
      Constants.GET_TASKS_SUCCESS,
      Constants.GET_TASKS_FAILED,
    )
    response.status === 200
      ? action.resolve()
      : action.reject(response.data?.error)
  } catch (error) {
    yield put({ type: Constants.GET_TASKS_FAILED, error })
  }
}

function* getTaskSummary(action: AnyAction) {
  try {
    const api_key: string = yield select(getApiKey)
    const response: IResponseStatus = yield call(
      Services.taskSummaryService,
      api_key,
    )

    yield call(
      parseResponse,
      response,
      Constants.GET_TASK_SUMMARY_SUCCESS,
      Constants.GET_TASK_SUMMARY_FAILED,
    )
    response.status === 200
      ? action.resolve()
      : action.reject(response.data?.error)
  } catch (error) {
    yield put({ type: Constants.GET_TASK_SUMMARY_FAILED, error })
  }
}

function* transitionTask(action: AnyAction) {
  try {
    const api_key: string = yield select(getApiKey)
    const response: IResponseStatus = yield call(
      Services.transitionTaskService,
      api_key,
      action.id,
      action.status,
      action.comment,
    )

    yield call(
      parseResponse,
      response,
      Constants.TRANSITION_TASK_SUCCESS,
      Constants.TRANSITION_TASK_FAILED,
    )
    response.status === 200
      ? action.resolve()
      : action.reject(response.data?.message)
  } catch (error) {
    yield put({ type: Constants.TRANSITION_TASK_FAILED, error })
  }
}

function* commentTask(action: AnyAction) {
  try {
    const api_key: string = yield select(getApiKey)
    const response: IResponseStatus = yield call(
      Services.commentTaskService,
      api_key,
      action.id,
      action.comment,
    )

    yield call(
      parseResponse,
      response,
      Constants.COMMENT_TASK_SUCCESS,
      Constants.COMMENT_TASK_FAILED,
    )
    response.status === 200 || response.status === 201
      ? action.resolve()
      : action.reject(response.data?.message)
  } catch (error) {
    yield put({ type: Constants.COMMENT_TASK_FAILED, error })
  }
}

function* bulkCloseTasks(action: AnyAction) {
  try {
    const api_key: string = yield select(getApiKey)
    const response: IResponseStatus = yield call(
      Services.bulkCloseTasksService,
      api_key,
      action.ids,
    )

    yield call(
      parseResponse,
      response,
      Constants.BULK_CLOSE_TASKS_SUCCESS,
      Constants.BULK_CLOSE_TASKS_FAILED,
    )
    // Le corps porte le détail — combien fermées, et ce qui a été écarté avec
    // son motif. Il remonte au composant, qui doit le dire à l'utilisateur.
    response.status === 200
      ? action.resolve(response.data)
      : action.reject(response.data?.message)
  } catch (error) {
    yield put({ type: Constants.BULK_CLOSE_TASKS_FAILED, error })
  }
}

// Tableau d'effets, et non générateur racine : c'est la forme attendue par
// `rootSaga`, qui étale chaque module dans son `all([...])`.
//
// `takeLatest` partout : seules des lectures, et un filtre changé rend la
// requête précédente sans intérêt.
export const tasksSagas = [
  takeLatest(Constants.GET_TASKS, getTasks),
  takeLatest(Constants.GET_TASK_SUMMARY, getTaskSummary),
  // takeEvery sur les écritures : deux tâches traitées coup sur coup sont deux
  // gestes distincts, et `takeLatest` annulerait le premier.
  takeEvery(Constants.TRANSITION_TASK, transitionTask),
  takeEvery(Constants.COMMENT_TASK, commentTask),
  takeEvery(Constants.BULK_CLOSE_TASKS, bulkCloseTasks),
]
